import type { UseQueryResult } from "@tanstack/react-query"
import { useQuery } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"

import { retrySolarRead } from "./solar-read-retry"
import type { SolarProposalSavingsSectionDto } from "../dto/solar-proposal-savings.dto"
import { solarProposalService } from "../services/solar-proposal.service"

/**
 * The Solar Proposal savings section read. Like the design and equipment reads, it loads
 * and fails apart from the header read, so its errors stay inside the section.
 */
export default function useSolarProposalSavings(
  proposalId: string | undefined,
): UseQueryResult<SolarProposalSavingsSectionDto, unknown> {
  return useQuery({
    queryKey: queryKeys.solarProposal.savings(proposalId ?? ``),
    queryFn: () => solarProposalService.getSavings(proposalId ?? ``),
    enabled: Boolean(proposalId),
    retry: retrySolarRead,
  })
}
